// en, de, fr, pt
export default {
  fr: {
    commons: {
      saveUpdate: 'Sauvegarder les modifications',
      cancelAndGoBack: 'Annuler et revenir en arrière',
      confirmPopoverMessage: 'Êtes-vous sûr(e) ?',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Annuler',
      defaultErrorMessage: 'Une erreur est survenue',
      defaultSuccessMessage: 'Opération réussie',
      updateSuccessMessage: 'Informations mises à jour',
      loading: 'Chargement...',
      choose: 'Choisir',
      missingInfo: 'Info manquante',
      operationCanceled: 'Opération annulée',
      continueButtonText: 'Continuer',
      requiredFieldMessage: 'Ce champ est requis',
    },
    roles: {
      SUPER_ADMIN: 'Super Admin',
      MANAGER_DE_SECTEUR: 'Manager de secteur',
      RESPONSABLE_MAGASIN: 'Responsable magasin',
      RESPONSABLE_MAGASIN_ADJOINT: 'Responsable magasin adjoint',
      PREMIER_VENDEUR: 'Premier vendeur',
      VENDEUR: 'Vendeur',
      APPRENTI_VENTE: 'Apprenti vente',
      RESPONSABLE_PRODUCTION: 'Responsable production',
      RESPONSABLE_PRODUCTION_ADJOINT: 'Responsable production adjoint',
      BOULANGER: 'Boulanger',
      PREPARATEUR: 'Préparateur',
      APPRENTI_BOULANGER: 'Apprenti boulanger',
    },
    loginPage: {
      title: 'Connectez-vous',
      usernameLabel: 'Nom utilisateur',
      passwordLabel: 'Mot de passe',
      submitButtonText: 'Se connecter',
      successMessage: 'Vous êtes connecté(e)',
      errorAccountDisabled: 'Votre compte est provisoirement désactivé',
      errorWrongPassword: 'Mot de passe invalide',
    },
    mainNav: {
      logoutMenuItem: 'Déconnexion',
      managePasswordsItem: 'Gestion mots de passe',
      profileMenuItem: 'Mon profil',
      manageUsersMenuItem: 'Gestion personnel',
    },
    shopSignInPage: {
      title: 'Connexion magasin',
      emailLabel: 'Adresse email du magasin',
      validEmailRequiredMessage: 'Un email valide est requis',
      submitButtonText: 'Se connecter',
      successMessage: 'Un lien de connexion vous a été transmis par email',
      shopMLVerificationSuccess: 'Votre magasin est enregistré !',
    },
    chooseUserPage: {
      chooseUserButtonText: 'Choisir',
    },
    userSignInForm: {
      passwordLabel: 'Mot de passe',
      validPasswordRequiredMessage: 'Le mot de passe est requis.',
      submitButtonText: 'Me connecter',
      forgotPassword: 'Mot de passe oublié',
      cancelForgotPassword: 'Annuler',
    },
    usersListTable: {
      openButtonText: 'Ouvrir',
    },
    addUserDialog: {
      title: 'Ajouter un utilisateur',
    },
    addUserForm: {
      firstnameLabel: 'Prénom(s)',
      lastnameLabel: 'Nom',
      chooseTitleLabel: 'Choisissez un poste',
      chooseRoleLabel: 'Choisissez un rôle',
      submitButtonText: 'Continuer',
      submitPasswordButtonText: 'Créer l\'utilisateur',
      cancelPasswordFormButtonText: 'Retour',
    },
    manageUsers: {
      title: 'Gestion du personnel',
      addUserButtonText: 'Ajouter un utilisateur',
    },
    removeUserDialog: {
      confirmMessageText: 'En supprimant cet utilisateur il perdra tous ses accès aux applications magasin. Continuer ?',
      confirmBoxTitle: 'Supprimer l\'utilisateur',
      confirmBoxButtonContinue: 'Supprimer',
      confirmBoxButtonCancel: 'Annuler',
    },
    resetPasswordForm: {
      passwordLabel: 'Nouveau mot de passe',
      passwordConfirmationLabel: 'Confirmation nouveau mot de passe',
      submitButtonText: 'Réinitialiser le mot de passe',
      resetPromptTitle: 'Réinitialisation du mot de passe',
      resetPromptMessage: 'Veuillez tapper votre nouveau mot de passe à 8 chiffres et un administrateur validera votre demande.',
      wrongPasswordFormatMessage: 'Votre mot de passe doit être composé exclusivement de 8 chiffres',
      wrongConfirmationMessage: 'Les deux mots de passe doivent être identiques',
      requestSentForApproval: 'Votre demande a été transmise.',
      confirmMessageText: 'Pour finaliser votre changement de mot de passe, appuyez sur "continuer"',
      confirmBoxTitle: 'Attention',
      confirmBoxButtonContinue: 'Continuer',
      confirmBoxButtonCancel: 'Annuler',
      requiresRecentLoginPromptTitle: 'Connexion nécessaire',
      requiresRecentLoginPromptMessage: 'Veuillez ajouter votre mot de passe actuel afin de procéder à sa modification',
    },
    profilePage: {
      title: 'Mon profil',
    },
    profile: {
      titleLabel: 'Poste',
      passwordLabel: 'Mot de passe',
      editPasswordLink: 'Modifier le mot de passe',
      editProfileLink: 'Modifier le profil',
      passwordChangeSuccess: 'Votre mot de passe a été mis à jour',
    },
  },
};
